import { v4 as uuid } from "uuid";

import { axios } from "utils";

import { PUBLIC_CARBON_PROGRAM_URL } from "consts";

import { CarbonProgram, CarbonProgramOutcomesResponse, IncentivesPotentialPayouts, ProgramContract, ProgramTermsConsent } from "models";

export const getCarbonProgramOutcomes = async (data: { fieldIds: string[] }): Promise<CarbonProgramOutcomesResponse> =>
  axios.post(`${PUBLIC_CARBON_PROGRAM_URL}/run`, { data }, { headers: { "run-id": uuid() }, timeout: 60000 });

export const getCarbonProgramById = async (programId: string): Promise<CarbonProgram> => axios.get(`${PUBLIC_CARBON_PROGRAM_URL}/${programId}`);

export const getCarbonProgramByFarmId = async (farmId: string): Promise<CarbonProgram> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${PUBLIC_CARBON_PROGRAM_URL}/farms/${farmId}`, { hideErrorMessage: true });

export const getIncentivesPotentialPayoutsByFarmId = async (farmId: string): Promise<IncentivesPotentialPayouts> =>
  axios.get(`${PUBLIC_CARBON_PROGRAM_URL}/incentives-potential-payouts?farmId=${farmId}`);

// carbon program terms & conditions

export const addProgramTermsConsent = async (data: { programId: string; accepted?: boolean }): Promise<ProgramTermsConsent> =>
  axios.post(`${PUBLIC_CARBON_PROGRAM_URL}/terms/consents`, { data });

export const getCarbonProgramContractByProgramId = async (programId: string): Promise<ProgramContract> =>
  axios.get(`${PUBLIC_CARBON_PROGRAM_URL}/terms/${programId}`);
